





















































import { Component, Mixins, Prop } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class CowsIcon extends Mixins() {
  @Prop({
    required: true,
  })
  isFemale: boolean
}
